import FormPage from './formPage';
import Vehiculier from './vehiculier'
import FieldSelect from './fields/fieldSelect';
import FieldText from './fields/fieldText';
import FieldDate from './fields/fieldDate';
import FieldYesNo from './fields/fieldYesNo';

const typeToSponsor = {'motoecole':'la moto-école','concessionnaire':'le concessionnaire'}

export default class FrontVehicule extends FormPage {
    constructor(props) {
        super(props);
        this.title = 'Votre véhicule'
        this.state = {
            showValidate:false,
            vehiculierReady:false
        }
        const me = this
        this.vehiculier = new Vehiculier( this.props.api, this.props.devis.params.marque, ()=>{me.setState({vehiculierReady:true})} )
    }

    next() {
        this.props.setPage('vous')
    }

    back() {
        this.props.setPage('vehicule')
    }

    doRender(container) {
        const me = this
        const params = this.props.devis.params
        if ( params.marque != this.vehiculier.getMarque() ) {
            this.vehiculier.selectMarque( params.marque )
        }
        return <>
            <div className="contentvbox extrabottom">
            <h1 className="top_title">Votre deux-roues</h1>

            <FieldSelect field="marque" container={container} options={this.state.vehiculierReady ? this.vehiculier.getMarques() : []}/>
            <FieldSelect field="modele" container={container} options={this.state.vehiculierReady ? this.vehiculier.getModeles() : []}/>
            <FieldText field="cylindree" container={container}/>
            <FieldYesNo field="homologue" container={container}/>
            <FieldYesNo field="carte_grise_france" container={container} />
            <FieldDate field="date_mise_en_circulation" container={container}/>
            <FieldDate field="date_acquisition" container={container}/>
            <FieldYesNo field="assur_23_mois" container={container}/>
            <FieldSelect field="usage" container={container}/>
            <FieldSelect field="carte_grise_titulaire" container={container}/>
            </div>
        </>
    }
}
